import { Upload } from 'antd';
import { useState } from 'react';
import { getBase64 } from '../../utils/file';

export const Avatar = ({
    value,
    onChange,
    size = 100,
    showLabel = true,
    label = 'Upload your avatar'
}) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState(value);

    const uploadButton = (
        <div
            className="flex flex-col items-center justify-center text-gray-500 rounded-full border-2 border-dashed border-gray-300 hover:border-blue-400 transition-colors"
            style={{ width: size, height: size }}>
            <svg
                className="w-8 h-8 mb-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                />
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                />
            </svg>
            <span className="text-sm font-medium">Upload</span>
        </div>
    );

    const handleChange = (info) => {
        const file = info.file;
        if (file) {
            setLoading(true);
            getBase64(file, (url) => {
                setLoading(false);
                setImageUrl(url);
                onChange?.(file);
            });
        }
    };

    const handleRemove = (e) => {
        e.stopPropagation();
        setImageUrl(null);
        onChange?.(null);
    };

    const handlePreview = (e) => {
        e.stopPropagation();
        window.open(imageUrl, '_blank');
    };

    return (
        <div className="mx-auto flex flex-col items-center justify-center">
            <Upload
                maxCount={1}
                listType="picture-circle"
                className="w-fit"
                showUploadList={false}
                beforeUpload={() => false}
                onChange={handleChange}>
                {imageUrl ? (
                    <div className="relative group">
                        <img
                            draggable={false}
                            src={imageUrl}
                            alt="avatar"
                            className="rounded-full object-cover"
                            style={{ width: size, height: size }}
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                            <div className="flex space-x-2">
                                <button
                                    type="button"
                                    className="text-white hover:text-blue-300 transition-colors"
                                    onClick={handlePreview}>
                                    <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                        />
                                    </svg>
                                </button>
                                {/* <button
                                    type="button"
                                    className="text-white hover:text-red-300 transition-colors"
                                    onClick={handleRemove}>
                                    <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                        />
                                    </svg>
                                </button> */}
                            </div>
                        </div>
                    </div>
                ) : (
                    uploadButton
                )}
            </Upload>
            {showLabel && <label className="text-center mt-2">{label}</label>}
        </div>
    );
};
